import { render, staticRenderFns } from "./EmergencyOrderButton.vue?vue&type=template&id=593a04ee"
import script from "./EmergencyOrderButton.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports